export const ACCEPTED_MEDIA_TYPES = [
  'image/png',
  'image/gif',
  'image/jpeg',
  'video/mp4',
  'video/mkv',
  'video/quicktime',
  'video/avi',
  'video/x-flv',
  'video/mpeg',
  'video/webm',
  'video/3gpp',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.doc',
  '.docx',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  '.csv',
  '.xls',
  '.xlsx',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.ppt',
  '.pptx',
  'text/plain',
].join(', ');

export const IMAGE_MIME_TYPES = ['image/png', 'image/gif', 'image/jpeg'];
export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/mkv',
  'video/quicktime',
  'video/avi',
  'video/x-flv',
  'video/mpeg',
  'video/webm',
  'video/3gpp',
];
